<template>
    <div class="display-banner">
        <div v-if="fetchingBookingPortalImage" class="display-banner-img w-100 d-flex align-items-center justify-content-center">
            <span class="inline-loader d-md-block d-none h-100"></span>
            <span class="inline-loader d-md-none d-block"></span>
        </div>
        <img v-else-if="bookingPortalImage" class="display-banner-img" :src="bookingPortalImage.thumbnails.large" alt="Banner" >
        <img v-else src="@/assets/Images/OnlineBooking_Header_Default.png" alt="display-header" class="display-banner-img">
    </div>
</template>

<script>
/* eslint-disable */
    import { BookingPortalImageCacheMixin } from '@/mixins/Booking/BookingPortalImageCacheMixin';

    export default {
        name: 'DisplayBanner',
        mixins: [BookingPortalImageCacheMixin],
    }
</script>